import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import getConversationsApi from "../../helpers/chat/getConversationAPI";
import {
  addNewMessageSuccessInChatList,
  deleteFileError,
  deleteFileSuccess,
  getConversationSuccess,
  uploadFileError,
  uploadFileSuccess,
} from "./actions";
import {
  ADD_NEW_MESSAGE,
  DELETE_FILE,
  GET_CONVERSATION,
  UPLOAD_FILE,
} from "./constants";

function* addMessage({ payload }: any) {
  const { message } = payload;
  yield put(addNewMessageSuccessInChatList(message));
}

export function* watchAddMessage() {
  try {
    yield takeEvery(ADD_NEW_MESSAGE, addMessage);
  } catch (error) {
    // Empty error
  }
}

function* getConversation() {
  try {
    const response: any = yield call(getConversationsApi);

    yield put(getConversationSuccess(response));
  } catch (error) {
    // Empty error
  }
}

export function* watchGetConversation() {
  yield takeEvery(GET_CONVERSATION, getConversation);
}

function* uploadFile({ payload }: any) {
  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append("file", file);

    const response = yield call(
      fetch,
      `${process.env.REACT_APP_HOST}/file-upload/upload`,
      {
        method: "POST",
        body: formData,
      },
    );

    if (response.ok) {
      const result = yield call([response, "json"]);
      yield put(uploadFileSuccess(result.url));
    } else {
      yield put(uploadFileError("Greška pri upload-u fajla."));
    }
  } catch (error) {
    yield put(uploadFileError("Greška pri upload-u fajla."));
  }
}

export function* watchUploadFile() {
  yield takeEvery(UPLOAD_FILE, uploadFile);
}

function* deleteFile({ payload }: any) {
  try {
    const { filePath } = payload;

    const response = yield call(
      fetch,
      `${process.env.REACT_APP_HOST}/file-upload/delete`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filePath }),
      },
    );

    if (response.ok) {
      yield put(deleteFileSuccess());
    } else {
      yield put(deleteFileError("Greška pri brisanju fajla."));
    }
  } catch (error) {
    yield put(deleteFileError("Greška pri brisanju fajla."));
  }
}

export function* watchDeleteFile() {
  yield takeEvery(DELETE_FILE, deleteFile);
}

function* chatMessagesSaga() {
  yield all([
    fork(watchAddMessage),
    fork(watchGetConversation),
    fork(watchUploadFile),
    fork(watchDeleteFile),
  ]);
}

export default chatMessagesSaga;
